// File: extensions/belt-size-chart/assets/size-chart.js

(function() {
  'use strict';

  // Configuration
  const config = {
    modalId: 'belt-size-chart-modal',
    buttonClass: 'belt-size-chart-btn',
    productTags: ['belt', 'leather-belt', 'mens-belt'], // Tags to trigger size chart
  };

  // Size chart data
  const sizeChartData = [
    { waist: '28"', beltSize: '30 in', label: 'S' },
    { waist: '30"', beltSize: '32 in', label: 'S / M' },
    { waist: '32"', beltSize: '34 in', label: 'M' },
    { waist: '34"', beltSize: '36 in', label: 'M / L' },
    { waist: '36"', beltSize: '38 in', label: 'L' },
    { waist: '38"', beltSize: '40 in', label: 'L / XL' },
    { waist: '40"', beltSize: '42 in', label: 'XL' },
    { waist: '42"', beltSize: '44 in', label: 'XL / XXL' },
    { waist: '44"', beltSize: '46 in', label: 'XXL' },
  ];

  // Check if product has belt tags
  function isBeltProduct() {
    const productType = window.meta?.product?.type?.toLowerCase() || '';
    const productTags = window.meta?.product?.tags || [];
    
    return config.productTags.some(tag => 
      productTags.includes(tag) || productType.includes('belt')
    );
  }

  // Create size chart modal HTML
  function createModal() {
    const modal = document.createElement('div');
    modal.id = config.modalId;
    modal.className = 'belt-size-chart-modal';
    modal.innerHTML = `
      <div class="belt-size-chart-overlay"></div>
      <div class="belt-size-chart-content">
        <button class="belt-size-chart-close" aria-label="Close">&times;</button>
        <div class="belt-size-chart-inner">
          <h2>BELT </h2>
          <p class="belt-size-formula">Choose belt size = <strong>Waist size + 2 inches</strong></p>
          
          <table class="belt-size-table">
            <thead>
              <tr>
                <th>Waist Size<br>(inches)</th>
                <th>Recommended<br>Belt Size (inches)</th>
                <th>Typical Label</th>
              </tr>
            </thead>
            <tbody>
              ${sizeChartData.map(row => `
                <tr>
                  <td>${row.waist}</td>
                  <td>${row.beltSize}</td>
                  <td>${row.label}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <div class="belt-size-notes">
            <p><span class="scissors-icon">✂</span> Auto-lock belts are <strong>cut-to-fit</strong> for a perfect finish.</p>
            <p>Excess length can be trimmed from the buckle end in Reversible and Autolock Belts.</p>
          </div>
        </div>
      </div>
    `;
    return modal;
  }

  // Create size chart button
  function createButton() {
    const button = document.createElement('button');
    button.className = config.buttonClass;
    button.type = 'button';
    button.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 13H7V7h2v6zm0-8H7V3h2v2z" fill="currentColor"/>
      </svg>
      
    `;
    return button;
  }

  // Add CSS styles
  function addStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .${config.buttonClass} {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: 1px solid #333;
        padding: 8px 16px;
        margin: 12px 0;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        color: #333;
        transition: all 0.3s ease;
      }
      
      .${config.buttonClass}:hover {
        background: #333;
        color: #fff;
      }
      
      .belt-size-chart-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
        display: none;
        align-items: center;
        justify-content: center;
      }
      
      .belt-size-chart-modal.active {
        display: flex;
      }
      
      .belt-size-chart-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
      }
      
      .belt-size-chart-content {
        position: relative;
        background: #f5f0eb;
        max-width: 800px;
        width: 90%;
        max-height: 90vh;
        overflow-y: auto;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      }
      
      .belt-size-chart-close {
        position: absolute;
        top: 15px;
        right: 15px;
        background: none;
        border: none;
        font-size: 32px;
        cursor: pointer;
        color: #333;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
      }
      
      .belt-size-chart-inner {
        padding: 40px 30px;
        text-align: center;
      }
      
      .belt-size-chart-inner h2 {
        font-size: 28px;
        margin-bottom: 15px;
        color: #333;
        letter-spacing: 2px;
      }
      
      .belt-size-formula {
        font-size: 16px;
        margin-bottom: 30px;
        color: #555;
      }
      
      .belt-size-table {
        width: 100%;
        border-collapse: collapse;
        margin: 30px 0;
        background: white;
        border-radius: 8px;
        overflow: hidden;
      }
      
      .belt-size-table th {
        background: #fff;
        padding: 15px;
        text-align: center;
        font-weight: 600;
        font-size: 14px;
        color: #333;
        border-bottom: 2px solid #ddd;
      }
      
      .belt-size-table td {
        padding: 15px;
        text-align: center;
        border-bottom: 1px dashed #ddd;
        color: #555;
      }
      
      .belt-size-table tr:last-child td {
        border-bottom: none;
      }
      
      .belt-size-notes {
        margin-top: 30px;
        text-align: left;
        padding: 20px;
        background: white;
        border-radius: 8px;
      }
      
      .belt-size-notes p {
        margin: 10px 0;
        font-size: 14px;
        color: #555;
        line-height: 1.6;
      }
      
      .scissors-icon {
        margin-right: 8px;
        font-size: 18px;
      }
      
      @media (max-width: 768px) {
        .belt-size-chart-inner {
          padding: 30px 20px;
        }
        
        .belt-size-chart-inner h2 {
          font-size: 22px;
        }
        
        .belt-size-table th,
        .belt-size-table td {
          padding: 10px 5px;
          font-size: 12px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // Initialize the size chart
  function init() {
    // Check if we're on a product page
    if (!window.location.pathname.includes('/products/')) {
      return;
    }

    // Add styles
    addStyles();

    // Create and add modal to page
    const modal = createModal();
    document.body.appendChild(modal);

    // Find the product form and add button
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const button = createButton();
      
      // Try to insert near variant selector or add to cart button
      const variantSelector = productForm.querySelector('.product-form__input');
      const addToCartButton = productForm.querySelector('[name="add"]');
      
      if (variantSelector) {
        variantSelector.parentNode.insertBefore(button, variantSelector.nextSibling);
      } else if (addToCartButton) {
        addToCartButton.parentNode.insertBefore(button, addToCartButton);
      } else {
        productForm.appendChild(button);
      }

      // Add event listeners
      button.addEventListener('click', () => {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });

      const closeBtn = modal.querySelector('.belt-size-chart-close');
      const overlay = modal.querySelector('.belt-size-chart-overlay');

      const closeModal = () => {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      };

      closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', closeModal);

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('active')) {
          closeModal();
        }
      });
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();